import { sensorLiveDataConstants } from "../../constants/client";

const initialState = {};

export default function sensorLiveData(state = initialState, action) {
  let oldstate = state;
  let currentstate = false;

  switch (action.type) {
    case sensorLiveDataConstants.LIVE_DATA_REQUEST:
      currentstate = {
        data: null,
        loading: true
      };
      break;
    case sensorLiveDataConstants.LIVE_DATA_SUCCESS:
      currentstate = {
        data: action.payload.data,
        loading: false
      };
      break;
    case sensorLiveDataConstants.LIVE_DATA_FAILURE:
      currentstate = { error: action.payload, loading: false };
      break;

    default:
      break;
  }

  if (!!currentstate) {
    return { ...oldstate, ...currentstate };
  } else {
    return oldstate;
  }
}
